import RequestAbstract from "../abstract";

export default class CallbackprocessorUrlCallbacks extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/callbackprocessor-url-callbacks";
    }

}
